import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_REQUEST = 'LOAD_FORM_FILTERS_REQUEST';
export const LOAD_SUCCESS = 'LOAD_FORM_FILTERS_SUCCESS';
export const LOAD_FAIL = 'LOAD_FORM_FILTERS_FAIL';
export const LOAD_OPTIONS_SUCCESS = 'LOAD_FORM_FILTERS_OPTIONS_SUCCESS';

export const SUBMIT_REQUEST = 'SUBMIT_FORM_FILTER_REQUEST';
export const SUBMIT_SUCCESS = 'SUBMIT_FORM_FILTER_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FORM_FILTER_FAIL';

export const DELETE_REQUEST = 'DELETE_FORM_FILTER_REQUEST';
export const DELETE_SUCCESS = 'DELETE_FORM_FILTER_SUCCESS';
export const DELETE_FAIL = 'DELETE_FORM_FILTER_FAIL';

const loadFormFiltersSuccess = (filters) => ({ type: LOAD_SUCCESS, filters });
const loadFormFiltersRequest = () => ({ type: LOAD_REQUEST });
const loadFormFiltersFail = (error) => ({ type: LOAD_FAIL, error });

const submitFormFiltersSuccess = (result) => ({ type: SUBMIT_SUCCESS, result });
const submitFormFiltersRequest = (request) => ({ type: SUBMIT_REQUEST, request });
const submitFormFiltersFail = (error) => ({ type: SUBMIT_FAIL, error });

const deleteFormFiltersSuccess = (filterId) => ({ type: DELETE_SUCCESS, filterId });
const deleteFormFiltersRequest = () => ({ type: DELETE_REQUEST });
const deleteFormFiltersFail = (error) => ({ type: DELETE_FAIL, error });

const updatePlannerFilter = (filter) => {
  const filterObject = JSON.parse(filter);
  if (typeof filterObject.date === 'string') {
    filterObject.date = {
      date: filterObject.date.split(',')[0],
      periodType: ['month']
    };
  }
  return JSON.stringify(filterObject);
};

const updatePlannerFilters = (filters) => filters.map((filter) => ({
  ...filter,
  Filter: updatePlannerFilter(filter.Filter)
}));

export const loadFormFilters = (ownerId, formName = '') => (dispatch) => {
  dispatch(loadFormFiltersRequest());
  const getParams = `?ownerId=${ownerId}&formId=${formName}`;
  return communicate({
    url: 'FormFilters',
    getParams
  })
    .then((response) => {
      if (formName === 'planner') {
        const updatedFilters = updatePlannerFilters(response.data.Data);
        dispatch(loadFormFiltersSuccess(updatedFilters));
      } else {
        dispatch(loadFormFiltersSuccess(response.data.Data));
      }
    }).catch((err) => {
      dispatch(loadFormFiltersFail(err));
      toastrError(err);
    });
};

export const submitFormFilter = (filter) => (dispatch) => {
  dispatch(submitFormFiltersRequest(filter));
  return communicate({ url: 'FormFilters', method: 'post', data: filter }).then((response) => {
    toastrSuccess(response);
    dispatch(submitFormFiltersSuccess(response.data));
    return Promise.resolve(response.data.Data);
  }).catch((err) => {
    dispatch(submitFormFiltersFail(err));
    toastrError(err);
    return Promise.reject(err);
  });
};

export const updateFormFilter = (filter) => (dispatch) => {
  dispatch(submitFormFiltersRequest());
  return communicate({ url: 'FormFilters', method: 'put', data: filter }).then((response) => {
    toastrSuccess(response);
    dispatch(submitFormFiltersSuccess(response.data));
    return Promise.resolve(response.data.Data);
  }).catch((err) => {
    dispatch(submitFormFiltersFail(err));
    toastrError(err);
    return Promise.reject(err);
  });
};

export const deleteFormFilter = (filter) => (dispatch) => {
  dispatch(deleteFormFiltersRequest());
  return communicate({ url: 'FormFilters', method: 'delete', getParams: `?id=${filter.id}&ownerId=${filter.ownerId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteFormFiltersSuccess(filter.id));
      return Promise.resolve();
    }).catch((err) => {
      dispatch(deleteFormFiltersFail(err));
      toastrError(err);
      return Promise.reject(err);
    });
};
